export const planColumns = () => {
  return [
    {
      Header: 'Plan ID',
      accessor: 'planId',
      editType: 'inputField',
      options: []
    },
    {
      Header: 'Plan Name',
      accessor: 'planName',
      editType: 'inputField',
      options: []
    },
    {
      Header: 'Planned Tonnage',
      accessor: 'plannedTonnage',
      editType: 'inputField',
      options: []
    },
    {
      Header: 'Planned Percent',
      accessor: 'plannedPercent',
      editType: 'inputField',
      options: []
    },
    {
      Header: 'Planned Date',
      accessor: 'plannedDate',
      editType: 'inputField',
      options: []
    },
    {
      Header: 'Planned By',
      accessor: 'plannedBy',
      editType: 'inputField',
      options: []
    },
    {
      Header: 'Plan Type',
      accessor: 'planType',
      editType: 'inputField',
      options: []
    }
  ];
}

export const demandColumns = () => {
  return [
    {
      Header: 'Zone',
      accessor: 'zoneName',
      editType: 'inputField',
      options: []
    },
    {
      Header: 'Equipment Description',
      accessor: 'equipmentDescription',
      editType: 'inputField',
      options: []
    },
    {
      Header: 'Consumable Code',
      accessor: 'consumableCode',
      editType: 'inputField',
      options: []
    },
    {
      Header: 'Consumable Description',
      accessor: 'consumableDescription',
      editType: 'inputField',
      options: []
    },
    {
      Header: 'Quantity Required',
      accessor: 'quantityRequired',
      editType: 'inputField',
      options: []
    },
    {
      Header: "Current Warehouse Qty.",
      accessor:"currentWarehouseQuantity",
      editType:'Number',
    }
  ];
}

export const productDistributionColumns = () => {
  return [
    {
      Header: 'Product Type',
      accessor: 'producType',
      editType: 'inputField',
      options: []
    },
    {
      Header: 'Product Dimension',
      accessor: 'productCode',
      editType: 'inputField',
      options: []
    },
    {
      Header: 'Product Percent',
      accessor: 'productPercent',
      editType: 'inputField',
      options: []
    },
    {
      Header: 'Product Tonnage',
      accessor: 'productTonnage',
      editType: 'inputField',
      options: []
    },
    {
      Header: 'Profile Percent',
      accessor: 'profilePercent',
      editType: 'inputField',
      options: []
    },
    {
      Header: 'Profile Tonnage',
      accessor: 'profileTonnage',
      editType: 'inputField',
      options: []
    }
  ];
}
